import { ReactNode } from "react";
import { Stack, Text } from "@mantine/core";

interface ObservationMetadataRowProps {
  label: string;
  children: ReactNode;
}

export default function ObservationMetadataRow({
  label,
  children,
}: ObservationMetadataRowProps) {
  return (
    <Stack gap={2} style={{ minWidth: 0 }}>
      <Text size="xs" fw={700} c="dimmed" tt="uppercase">
        {label}
      </Text>
      {children}
    </Stack>
  );
}
